import React, { useState } from "react";
import { pointsConfig } from "../../pointsConfig";
import MilesRankDetailModal from "../../components/modal/milesPoints/milesRankDetailModal/MilesRankDetailModal";

function MilesLeaderboardRankCard() {
  const [modal, setModal] = useState(false);
  return (
    <>
      <MilesRankDetailModal open={modal} setOpen={setModal} />
      <div
        className="rounded-lg bg-white w-full p-4 flex items-center justify-between cursor-pointer"
        onClick={() => setModal(true)}
      >
        <div className="flex items-center gap-3">
          <span>4</span>
          <div className="flex items-center gap-2">
            <img
              src={pointsConfig.ranks.legendary.icon}
              alt=""
              className="w-12 object-contain"
            />
            <div className="flex flex-1 flex-col">
              <span className="font-BrFirmaBold">Company Name Here</span>
              <span className="text-[#606060]">
                {pointsConfig.ranks.legendary.label}
              </span>
            </div>
          </div>
        </div>
        <div className="flex">
          <img src="/goldCoin.png" alt="" className="w-6 object-contain" />
          <span className="text-[#606060] text-xl ml-1">10,455</span>{" "}
        </div>
      </div>
    </>
  );
}

export default MilesLeaderboardRankCard;
